module.exports = __webpack_public_path__ + "res/4-img_info_m.a00ae4f612d0e8269fe07ce12dd46eaa.png";